export { default } from 'features/menu/pages/favorites-page/favorite-editor/favorite-editor';
